import { StyledBroadsiderFooter } from './BroadsiderFooter.styled';
import { MailchimpSubscribeForm } from '../';
import { openUrl } from '../../utils';
import MailchimpSubscribe from "react-mailchimp-subscribe";
import { MAILCHIMP_URL, IS_PRODUCTION } from '../../constants';

const BroadsiderFooter = () => {
  return (
    <StyledBroadsiderFooter>
      <div className='footer-main'>
	<div style={{maxWidth: '30rem'}}>
          <MailchimpSubscribe
            url={MAILCHIMP_URL}
            render={({ subscribe, status, message }) => (
              <MailchimpSubscribeForm subscribe={subscribe} status={status} message={message} />
	    )}
          />
        </div>
        <div className='footer-sections'>
	  <div className='footer-section-with-separator'>
	    <div className='footer-section-separator'/>
            <div className='footer-section'>
              <div className='footer-section-title'>Community</div>
              <div className='footer-section-link' onClick={() => openUrl('https://twitter.com/basejumpxyz')}>Twitter</div>
              <div className='footer-section-link' onClick={() => openUrl('http://discord.gg/basejump')}>Discord</div>
            </div>
          </div>
          <div className='footer-section-with-separator'>
	    <div className='footer-section-separator'/>
            <div className='footer-section'>
              <div className='footer-section-title'>Legal</div>
              <div className='footer-section-link' onClick={() => openUrl('/terms')}>Terms of Service</div>
              <div className='footer-section-link' onClick={() => openUrl('/privacy')}>Privacy Policy</div>
            </div>
          </div>
        </div>
      </div>
      <div className='separator' />
      <div className='footer-logo-container'>
        <img className='footer-logo' src='/assets/basejump_logo.svg' />
        <div className='footer-copyright'>
	  © 2022-{new Date().getFullYear()} DAZZLESHIP INC. ALL RIGHTS RESERVED
        </div>
      </div>
      {!IS_PRODUCTION && <div className='footer-debug'>
        <div className='footer-debug-text'>Debug</div>
        <button onClick={() => {throw new Error("This is your first error!");}}>Break the world</button>
      </div>}

    </StyledBroadsiderFooter>
  )
};

export default BroadsiderFooter;
